import { render, staticRenderFns } from "./ToDo.vue?vue&type=template&id=1309faaa&scoped=true&"
import script from "./ToDo.vue?vue&type=script&lang=js&"
export * from "./ToDo.vue?vue&type=script&lang=js&"
import style0 from "./ToDo.vue?vue&type=style&index=0&id=1309faaa&scoped=true&lang=css&"
import style1 from "./ToDo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1309faaa",
  null
  
)

export default component.exports